var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("BusinessStockEntryInformView.title")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.reFresh },
                },
                [_vm._v(_vm._s(_vm.$t("refreshText")))]
              ),
              _c("BjLogButton", {
                attrs: {
                  id: _vm.data.id,
                  permission: "BusinessStockEntryInformIndex_Log",
                  title: _vm.data.code,
                  api: "stockApi",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockEntryInformView.code"),
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.data.code || _vm.noDataText) + " "
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.code },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.receivingLogicWarehouseCode"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.receivingLogicWarehouseCode ||
                              _vm.noDataText
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.receivingLogicWarehouseName"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.receivingLogicWarehouseName ||
                              _vm.noDataText
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.inputTypeMeaning"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.inputTypeMeaning || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.statusMeaning"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.statusMeaning || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.returnsName"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.data.returnsName || _vm.noDataText) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.returnsMobile"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("phoneFilter")(_vm.data.returnsMobile)) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.cptAddress"
                        ),
                      },
                    },
                    [_vm._v(_vm._s(_vm.cptAddress) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.creationDate"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.creationDate || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("BjDivider", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessStockEntryInformView.logisticsInformation")
              )
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form",
                [
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.data.logisticsList
                            .map(function (item) {
                              return (
                                item.logisticsCompanyName +
                                " - " +
                                item.logisticsNo
                              )
                            })
                            .join("；")
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("BusinessStockEntryInformView.associated"))),
          ]),
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.frontRecordCode"
                        ),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onView(0)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.frontRecordCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.frontRecordCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockEntryInformView.orderCode"),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessOrderInternalView(
                                _vm.data.orderCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.orderCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.orderCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.platformOrderCode"
                        ),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessThirdOrderView(
                                _vm.data.platformOrderCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.platformOrderCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.platformOrderCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryInformView.resultCode"
                        ),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessStockEntryResultView(
                                _vm.data.resultCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.resultCode))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("BusinessStockEntryInformView.productInformation"))
        ),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "auto-fetch": false,
          serial: _vm.serial,
          selection: false,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "row-key": "id",
          "no-auto-height": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessStockEntryInformView.table.skuName"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessStockEntryInformView.table.skuCode"),
                    prop: "skuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessStockEntryInformView.table.plannedQty"
                    ),
                    prop: "plannedQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessStockEntryInformView.table.alreadyInputQty"
                    ),
                    prop: "alreadyInputQty",
                    align: "center",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationLeft",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessStockEntryInformView.totalQty")) +
                      "：" +
                      _vm._s(_vm.data.totalQty) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "ml20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockEntryInformView.alreadyTotalQty")
                    ) +
                      "：" +
                      _vm._s(_vm.data.alreadyTotalQty)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }